import { render, staticRenderFns } from "./VuesticFileUploadGalleryItem.vue?vue&type=template&id=2f83869a"
import script from "./VuesticFileUploadGalleryItem.vue?vue&type=script&lang=js"
export * from "./VuesticFileUploadGalleryItem.vue?vue&type=script&lang=js"
import style0 from "./VuesticFileUploadGalleryItem.vue?vue&type=style&index=0&id=2f83869a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f83869a')) {
      api.createRecord('2f83869a', component.options)
    } else {
      api.reload('2f83869a', component.options)
    }
    module.hot.accept("./VuesticFileUploadGalleryItem.vue?vue&type=template&id=2f83869a", function () {
      api.rerender('2f83869a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-file-upload-kyc/VuesticFileUploadGalleryItem.vue"
export default component.exports